import React from "react";
import UserRoleBudge from "./UserRoleBudge";
import styles from "./UserHeader.module.scss";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  name?: string;
  roles?: string[];
};

const UserHeader: React.FC<Props> = (props) => {
  const { name, roles } = props;

  return (
    <section className={styles["p-userHeader"]}>
      <div className={styles["p-userHeader__content"]}>
        <div
          className={styles["p-userHeader__content-namebox"]}
          data-testid="user-name"
        >
          <span className={styles["p-userHeader__content-namebox__label"]}>
            会員名
          </span>
          <span className={styles["p-userHeader__content-namebox__name"]}>
            {name}
          </span>
        </div>
        <div className={styles["p-userHeader__content-namebox__notes"]}>
          ※会員名はサイト上に公開されます
          <SonicLink to="/mypage/other-settings">変更はこちら</SonicLink>
        </div>
        <ul className={styles["p-userHeader__content-budges"]}>
          {roles
            ? roles.map((role, i) => <UserRoleBudge key={i} role={role} />)
            : null}
        </ul>
      </div>
    </section>
  );
};

export default UserHeader;
